const trimTrailingSlash = (value: string) => value.replace(/\/+$/, "");

const getRequiredEnv = (key: string): string => {
  const value = process.env[key]?.trim();
  if (!value) {
    throw new Error(`Missing required environment variable: ${key}`);
  }
  return trimTrailingSlash(value);
};

const apiUrl = getRequiredEnv("REACT_APP_API_URL");
const sepehrJouApiUrl = trimTrailingSlash(
  process.env.REACT_APP_SEPEHR_JOU_API_URL?.trim() || apiUrl,
);

export const API_BASE_URL = `${apiUrl}/api/v1`;
export const SEPEHR_JOU_API_BASE_URL = `${sepehrJouApiUrl}/api/v1`;

export const FILE_BASE_URL = (() => {
  const value = getRequiredEnv("REACT_APP_File_URL");
  return value.endsWith("/") ? value : `${value}/`;
})();
